export const VEHICLE_TYPES = ["Ambulance", "VSL", "Taxi", "TPMR"];
export const QUALIFICATIONS = ["DEA", "Auxiliaire", "Taxi", "Apprenti"];
export const DRIVER_STATUS = [
  { value: "disponible", label: "Disponible" },
  { value: "conges", label: "Congés" },
  { value: "maladie", label: "Maladie" },
  { value: "formation", label: "Formation" },
];
export const RIDE_TYPES = [
  { value: "sanitaire", label: "Sanitaire" },
  { value: "prive", label: "Privé" },
  { value: "tourisme", label: "Tourisme" },
];

export const DESTINATIONS = [
  { label: "CHU Dijon", lat: 47.327, lon: 5.082, address: "CHU François Mitterrand, Dijon" },
  { label: "Hôpital Beaune", lat: 47.024, lon: 4.84, address: "Centre Hospitalier de Beaune" },
  { label: "Hôpital Autun", lat: 46.951, lon: 4.299, address: "Centre Hospitalier d'Autun" },
  { label: "Hôpital Chalon", lat: 46.781, lon: 4.853, address: "Centre Hospitalier W. Morey, Chalon" },
];

export const STATUS_META = {
  planned: { label: "Planifié", cls: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300" },
  en_route: { label: "En route", cls: "bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300" },
  picked_up: { label: "Pris en charge", cls: "bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300" },
  finished: { label: "Terminé", cls: "bg-emerald-200 text-emerald-800 dark:bg-emerald-800/60 dark:text-emerald-200" },
};

export const STATUS_FLOW = ["planned", "en_route", "picked_up", "finished"];

export function today() {
  // Date locale (fuseau utilisateur) : évite le décalage UTC qui affichait
  // la journée précédente en soirée pour les fuseaux avancés (ex. Europe/Paris).
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
